import styled from 'styled-components';

export const Container = styled.div`
  margin: 20px;
  padding: 10px;
  flex: 1;
  align-items: center;

  p {
    font-size: 12px;
  }
`;
